import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { Treaty } from '@elysiajs/eden';

export function useTreatyQuery<T extends Record<number, unknown>>(
  props: Omit<
    UseQueryOptions<Treaty.Data<Treaty.TreatyResponse<T>>, Treaty.Error<Treaty.TreatyResponse<T>>['value']>,
    'queryFn'
  > & { queryFn: () => Promise<Treaty.TreatyResponse<T>> },
) {
  return useQuery({
    ...props,
    queryFn: async () => {
      const response = await props.queryFn();
      if (response.error) {
        throw response.error.value;
      }
      return response.data!;
    },
  });
}
